import { cx } from '@linaria/core';
import { useState, useEffect } from 'react';
import { FORMAT_SIZE_IN_MM } from '../constants.js';
import { section } from './comp.section.style.js';
import { OffsetPhysicalPages } from './offset-pages/_offset-pages.js';
import { tokens, pxToMMConversionCls } from './shared.size-tokens.style.js';
import { SplitPhysicalPages } from './split-pages/_split-pages.js';
import { jsx } from 'react/jsx-runtime';

/**
 * renders all content within a provided section.
 *
 * @NB Once pages of the section has finalized their layout and know the total
 *     amount of physical pages, then this data will be propagated upwards such
 *     that headers/footers can be rendered with the correct physical contexts.
 */
function Section(props) {
  const pages = props.section.pages.filter(it => !!it);
  const [pageToPhysicalPageMapping, setMapping] = useState(new Array(pages.length).fill(undefined));
  const hasPhysicalContextData = pageToPhysicalPageMapping.every(it => typeof it === "number");
  const physicalSize = FORMAT_SIZE_IN_MM[props.format];
  const designAspectRatio = props.section.config.designSizeInPx.width / props.section.config.designSizeInPx.height;
  const physicalAspectRatio = physicalSize.width / physicalSize.height;
  if (Math.abs(designAspectRatio - physicalAspectRatio) > 0.005) {
    console.warn("populatePrintTarget.Section: Provided designSize aspectRatio does not match provided format!", props.format, props.section.config.designSizeInPx, physicalSize);
  }
  const onPhysicalPageRenderComplete = (pageIndexInSection, amountOfPhysicalPagesInPrintPage) => {
    setMapping(prev => {
      const next = [...prev];
      next[pageIndexInSection] = amountOfPhysicalPagesInPrintPage;
      return next;
    });
  };

  // Once all physical pages have been rendered in this section, then update
  // our root of the actual amount of physical pages within this section.
  useEffect(() => {
    if (hasPhysicalContextData) {
      props.onPhsyicalPagesRenderedInSection(props.virtualContext.sectionIndex, pageToPhysicalPageMapping.reduce((acc, curr) => acc + curr, 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasPhysicalContextData]);
  return /*#__PURE__*/jsx("div", {
    className: cx(section, pxToMMConversionCls, props.section.className),
    style: tokens.__override({
      designHeightInPx: props.section.config.designSizeInPx.height,
      designWidthInPx: props.section.config.designSizeInPx.width,
      physicalPageHeightInMM: physicalSize.height,
      physicalPageWidthInMM: physicalSize.width
    }),
    children: pages.map((it, index) => {
      const virtualContext = {
        currentPageIndexInSection: index,
        currentPageIndexInDocument: index + props.virtualContext.startPageIndex,
        pagesInDocument: props.virtualContext.pagesInDocument,
        pagesInCurrentSection: pages.length,
        currentSectionIndex: props.virtualContext.sectionIndex,
        sectionsInDocument: props.virtualContext.sectionsInDocument
      };
      const indexInSection = pageToPhysicalPageMapping.slice(0, index).reduce((acc, curr) => acc + curr, 0);
      const physicalContext = hasPhysicalContextData && props.physicalContext ? {
        currentPageIndexInSection: indexInSection,
        currentPageIndexInDocument: indexInSection + props.physicalContext.startPageIndex,
        pagesInDocument: props.physicalContext.pagesInDocument,
        pagesInCurrentSection: pageToPhysicalPageMapping.reduce((acc, curr) => acc + curr, 0),
        currentSectionIndex: props.physicalContext.sectionIndex,
        sectionsInDocument: props.physicalContext.sectionsInDocument
      } : undefined;
      switch (it.type) {
        case "offset":
          return /*#__PURE__*/jsx(OffsetPhysicalPages, {
            target: props.target,
            config: props.section.config,
            page: it,
            context: {
              format: props.format,
              virtual: virtualContext,
              physical: physicalContext
            },
            onPhysicalPagesRendered: onPhysicalPageRenderComplete
          }, index);
        case "split":
          return /*#__PURE__*/jsx(SplitPhysicalPages, {
            target: props.target,
            config: props.section.config,
            page: it,
            context: {
              format: props.format,
              virtual: virtualContext,
              physical: physicalContext
            },
            onPhysicalPagesRendered: onPhysicalPageRenderComplete
          }, index);
      }
    })
  });
}

export { Section };
//# sourceMappingURL=comp.section.js.map
